import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import css from "./TopText.module.scss";
import { THEMES, getThemeClassNames } from 'constants/themes';

class TopText extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    theme: PropTypes.oneOf(
      Object.keys(THEMES).map(s => THEMES[s])
   ),
  };

  static defaultProps = {
    theme: THEMES.lightgray
  };

  render() {
    const { text, theme } = this.props;

    return (
      <div className={cn(css.block, getThemeClassNames(css, theme))}>
          <div
            className={cn(css.text, "top-text")}
            dangerouslySetInnerHTML={{ __html: text }}
          />
      </div>
    );
  }
}

export default TopText;



// WEBPACK FOOTER //
// ./src/components/TopText/TopText.jsx